export const IBillingAriaEtab = Object.freeze({
  id: "id",
  name: "name",
  balance: "balance",
  authorizedAmount: "authorized_amount",
  remainingAmount: "remaining_amount",
  ariaUrl: "aria_url",
  stripeUrl: "stripe_url",
});

export class BillingAriaEtabModel {
  constructor(data = {}) {
    this[IBillingAriaEtab.id] = data[IBillingAriaEtab.id];
    this[IBillingAriaEtab.name] = data[IBillingAriaEtab.name];
    this[IBillingAriaEtab.balance] = data[IBillingAriaEtab.balance];
    this[IBillingAriaEtab.authorizedAmount] = data[IBillingAriaEtab.authorizedAmount];
    this[IBillingAriaEtab.remainingAmount] = data[IBillingAriaEtab.remainingAmount];
    this[IBillingAriaEtab.ariaUrl] = data[IBillingAriaEtab.ariaUrl];
    this[IBillingAriaEtab.stripeUrl] = data[IBillingAriaEtab.stripeUrl];
  }

  getId() {
    return this[IBillingAriaEtab.id];
  }

  getName() {
    return this[IBillingAriaEtab.name];
  }

  getBalance() {
    return this[IBillingAriaEtab.balance];
  }

  getAuthorizedAmount() {
    return this[IBillingAriaEtab.authorizedAmount];
  }

  getRemainingAmount() {
    return this[IBillingAriaEtab.remainingAmount];
  }

  getAriaUrl() {
    return this[IBillingAriaEtab.ariaUrl];
  }

  getStripeUrl() {
    return this[IBillingAriaEtab.stripeUrl];
  }
}
